import { useState } from 'react';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { POATypes, uploadGenericSnapshot } from '@Services/api/uploadSnapshot';
import { buildNavigationStack } from '@Services/init/buildNavigationStack.service';
import { reportActOnUboCenter } from '../OwnersCenterAnalytics';
import type { UboResponse } from '@Store/index';

export const useOwnersCenterSubmit = (businessOwners: UboResponse[] | undefined) => {
  const { navigateToNextPage } = useNavigationManager();
  const [isLogicLoading, setIsLogicLoading] = useState(false);

  const handleSubmit = async () => {
    reportActOnUboCenter(businessOwners?.length ?? 0);

    await buildNavigationStack({
      shouldAvoidPickUpWhereLeft: true,
      shouldAvoidNavigation: true,
    });

    setIsLogicLoading(true);
    await uploadGenericSnapshot({ fileUsageType: POATypes.OWNERS_CENTER });
    setIsLogicLoading(false);
    navigateToNextPage(RoutesMap.OWNER_CENTER);
  };

  return { handleSubmit, isLogicLoading };
};
